import React, { Component } from "react";

import Create from "./Create";

class CreateShippingContainer extends Component {
  constructor() {
    super();
    this.openAndSetRecord = this.openAndSetRecord.bind(this);
  }

  state = {
    open: false
  };

  openAndSetRecord = record =>
    this.setState({
      open: true,
      shippingRecord: Object.assign({}, record)
    });

  close = () => {
    this.setState({ open: false, shippingRecord: null });
  };

  render() {
    const { open, shippingRecord } = this.state;

    if (!open) {
      return null;
    }

    return (
      <Create open={open} close={this.close} shippingRecord={shippingRecord} />
    );
  }
}

export default CreateShippingContainer;



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Create/Container.jsx